import {WinPresentationController} from "../WinPresentationController";
import {Oktoberfest} from "../../Oktoberfest";
import {TimelineLite} from "gsap";
import {ReelState} from "../../../core/reel/ReelState";

/**
 * Created by Shikha Gupta on 01/12/2021.
 */

export class OktoberfestStackedWildsWPController extends WinPresentationController {

    constructor() {
        super("OktoberfestStackedWildsWPController", false);
    }

    protected hasWin(): boolean {
        const isRespin: boolean = Oktoberfest.model.parsedGameData.mode === "WILD_RESPIN";
        const isNextModeNormal: boolean = Oktoberfest.model.parsedGameData.nextMode === "NORMAL";
        const isFirstOverLayWild: boolean = Oktoberfest.model.parsedGameData.overlayWilds[2][0] !== null;
        if(isRespin && !isNextModeNormal){
            Oktoberfest.reels[1].reelState = ReelState.INACTIVE;
            Oktoberfest.reels[3].reelState = ReelState.INACTIVE;
            Oktoberfest.reels[2].reelState = ReelState.INACTIVE;
        }else{
             Oktoberfest.reels[1].reelState = ReelState.ACTIVE;
             Oktoberfest.reels[3].reelState = ReelState.ACTIVE;
             Oktoberfest.reels[2].reelState = ReelState.ACTIVE;
        }
        return isRespin && isFirstOverLayWild;
    }


    protected playAllWinAnimation(resolve: () => void) {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                resolve();

            }
        });
        tl.add(Oktoberfest.stackWPs.startAnimation());

    }

    protected async createWinAnimation(): Promise<void> {
        const tl: TimelineLite = new TimelineLite();
        let delay: number = 0;
        tl.to(this, {duration: 0.1});
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            this.playAllWinAnimation(resolve);
        });
    }

}
